import React, { useEffect, useState } from 'react';
import Linkify from 'linkifyjs/react';

import AppIcon from '../../components/AppIcon';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';

import { fetchCurrentManuscriptInbox, fetchRankedSubmissions } from '../../modules/manuscriptInbox';
import { authUtil, uxAnalyticsUtil } from '../../utils';
import ReceivedManuscriptsTabPane from '../../components/manuscript-inbox/recievedMansucriptsTabPane';
import { PaddedWrapper } from '../../style';

const sortOptions = [
  {
    key: 'ranking',
    text: 'ranking',
    value: 'ranking'
  },
  {
    key: 'createdAt',
    text: 'createdAt',
    value: 'createdAt'
  }
];
export const Inbox = () => {
  const [sortBy, setSortBy] = useState('createdAt');
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { inboxId } = useParams();
  const location = useLocation();

  const currentManuscriptInbox = useSelector(state => state.manuscriptInbox.currentManuscriptInbox);

  useEffect(() => {
    const getInbox = async () => {
      const idToken = await authUtil.getFreshIdToken();
      dispatch(fetchCurrentManuscriptInbox(idToken, { _id: inboxId }));
      dispatch(fetchRankedSubmissions(idToken, { _id: inboxId, sortBy }));
    };
    getInbox();
    uxAnalyticsUtil.trackPageView(location.pathname);
  }, [inboxId]); // only run on first render

  useEffect(() => {
    const updateSubmissionsList = async () => {
      const idToken = await authUtil.getFreshIdToken();
      dispatch(fetchRankedSubmissions(idToken, { _id: inboxId, sortBy }));
    };
    uxAnalyticsUtil.trackEvent({
      category: uxAnalyticsUtil.categories.MANUSCRIPT_INBOX,
      action: 'changed_sorting',
      label: sortBy
    });
    updateSubmissionsList();
  }, [sortBy, inboxId]); // run every time sortBy changes

  const handleSortingChange = event => {
    setSortBy(event.target.value);
  };

  if (currentManuscriptInbox) {
    return (
      <PaddedWrapper>
        <header style={{display: 'flex', alignItems: 'center', gap: 12}}>
          <AppIcon name='inbox' size='large' />
          <h1>{currentManuscriptInbox.title}</h1>
          <span aria-label={t('Submissions')} style={{borderRadius: '1rem',
            padding: '0.25rem 0.6rem', background: 'var(--br-warning-surface)',
            color: 'var(--br-warning-text)'}}>
            {Array.isArray(currentManuscriptInbox.submissions)
              ? currentManuscriptInbox.submissions.length : 0}
          </span>
        </header>
        <div style={{whiteSpace: 'pre-wrap'}}>
          <Linkify>{currentManuscriptInbox.description}</Linkify>
        </div>
        <hr />
        <label className='br-field'>
          <span className='br-field__label'>{t('SortBy')}</span>
          <select className='br-field__input' value={sortBy} onChange={handleSortingChange}>
            {sortOptions.map(option =>
              <option key={option.key} value={option.value}>{t(option.text)}</option>)}
          </select>
        </label>
        {
          currentManuscriptInbox.submissions?.length > 0
          && <ReceivedManuscriptsTabPane submissions={currentManuscriptInbox.submissions} />
        }
      </PaddedWrapper>
    );
  }
  return (
    <PaddedWrapper>
      <p>{t('NothingHere')}</p>
    </PaddedWrapper>
  );
}

export default Inbox;
